import Mango from '@front/helpers/mango'
import { captureWishlistError } from '@front/helpers/sentry'

// Same wish list calls as the website (front/src/components/products/wishlist-modal.vue).

export function listHasProduct(list, product) {
	return (list?.items || []).some((i) => {
		const ref = Array.isArray(i.product) ? i.product[0] : i.product
		return (product.bcId && i.productBcId === product.bcId) || (ref?.id || ref) === product.id
	})
}

export function isSaved(store, product) {
	return (store.wishlists || []).some((list) => listHasProduct(list, product))
}

export async function syncWishlists(store) {
	if (!store?.user?.id) return
	const lists = await Mango.wishlists({ search: { author: store.user.id }, limit: 100 })
	if (Array.isArray(lists)) store.wishlists = lists
}

export async function addToWishlist(store, list, product) {
	if (listHasProduct(list, product)) return { ok: true, already: true }
	const item = { name: product.name, product: [product.id], productBcId: product.bcId }
	const response = await Mango.wishlists.save({ id: list.id, $push: { items: item } })
	if (!response?.id) return { ok: false }
	list.items = [...(list.items || []), item]
	await syncWishlists(store).catch(() => {})
	return { ok: true }
}

export async function createWishlist(store, name) {
	try {
		const response = await Mango.wishlists.save({ name, isPublic: false, bcCustomerId: store?.user?.bcId || null, items: [] }, false, true)
		if (response?.response?.id && !response?.warnings) {
			const created = { items: [], ...response.response }
			store.wishlists = [...(store.wishlists || []), created]
			return { ok: true, list: created }
		}
		const warning = Array.isArray(response?.warnings) ? response.warnings.filter(Boolean).join(' ') : response?.warnings
		captureWishlistError(warning || 'createWishlist failed', { action: 'createWishlist', warnings: response?.warnings, store, extra: { listName: name } })
		return { ok: false, message: warning || 'We couldn’t create that list. Please try again.' }
	} catch (error) {
		captureWishlistError(error, { action: 'createWishlist', store, extra: { listName: name } })
		return { ok: false, message: 'We couldn’t create that list. Please try again.' }
	}
}
